import axios from 'axios';
import logger from './logger';

// Global error handler function - will be set by the AuthContext
let globalErrorHandler = null;

export const setGlobalErrorHandler = (handler) => {
    globalErrorHandler = handler;
};

export const setupAuthInterceptor = () => {
    // Add a response interceptor
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response) {
                // Handle 401 (Unauthorized) or 403 (Forbidden) errors
                if (error.response.status === 401 || error.response.status === 403) {
                    logger.warn('Authentication error detected:', error.response.status);
                    
                    // Try to use the global error handler first
                    if (globalErrorHandler) {
                        try {
                            globalErrorHandler(error);
                            return Promise.reject(error);
                        } catch (e) {
                            // If global handler fails, fall back to direct handling
                        }
                    }
                    
                    // Fallback: Clear local storage and redirect
                    logger.warn('Falling back to direct logout handling');
                    localStorage.clear();
                    window.location.href = '/';
                }
            }
            return Promise.reject(error);
        }
    );

    // Add a request interceptor to check token expiration
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    // Check if token is expired
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    if (payload.exp * 1000 < Date.now()) {
                        logger.warn('Token expired during request');
                        
                        // Try to use the global error handler first
                        if (globalErrorHandler) {
                            try {
                                globalErrorHandler({ message: 'Token expired' });
                                return Promise.reject('Token expired');
                            } catch (e) {
                                // If global handler fails, fall back to direct handling
                            }
                        }
                        
                        // Fallback: Clear local storage and redirect
                        localStorage.clear();
                        window.location.href = '/';
                        return Promise.reject('Token expired');
                    }
                } catch (e) {
                    logger.error('Error checking token:', e);
                    
                    // Try to use the global error handler first
                    if (globalErrorHandler) {
                        try {
                            globalErrorHandler({ message: 'Invalid token' });
                            return Promise.reject('Invalid token');
                        } catch (err) {
                            // If global handler fails, fall back to direct handling
                        }
                    }
                    
                    // Fallback: Clear local storage and redirect
                    localStorage.clear();
                    window.location.href = '/';
                    return Promise.reject('Invalid token');
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
}; 